import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import summaryProgress from "../../images/summary_progress.svg";
import star from "../../images/star.svg";

/**
 * Component shown when transcription is actively running
 * Shows transcription in progress with optional requester information
 */
const TranscribingIndicator = ({ 
  rtmsRequesterName, 
  isRtmsStartedByOther
}) => {
  return (
    <Column alignmentHorizontal="start" width="100%" position="relative" spacing="none" spacingInset="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" minWidth="15px" />
        </Theme>
        <Box width="340px" position="relative">
          <img src={summaryProgress} alt="transcribingInProgress" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
        </Box>
      </Row>
      <Column height="16px" spacing="none" />
      <Column spacing="none">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" minWidth="68px"></Box>
          </Theme>
          <Text fontFamily="amazonEmber" type="h50" alignment="center">
            Transcribing...
          </Text>
        </Row>
      </Column>

      {rtmsRequesterName && isRtmsStartedByOther && (
        <>
          <Column height="48px" spacing="none" />
          <Row spacing="none" spacingInset="none">
            <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
              <Box type="outline" spacingInset="none" minWidth="68px"></Box>
            </Theme>
            <Theme tokens={{ boxBorderColorOutline: "#AFE8D7" }}>
              <Box type="outline" spacingInset="400" width="252px">
                <Row spacing="none">
                  <img src={star} alt="star" />
                  <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
                    <Box type="outline" spacingInset="none" minWidth="8px"></Box>
                  </Theme>
                  <Column spacing="none">
                    <Text fontFamily="amazonEmber" type="h50" alignment="start">
                      {rtmsRequesterName}
                    </Text>
                    <Text fontFamily="amazonEmber" type="b200" alignment="start">
                      started transcription
                    </Text>
                  </Column>
                </Row>
              </Box>
            </Theme>
          </Row>
        </>
      )}
    </Column>
  );
};

export default TranscribingIndicator;
